/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/KlondikeTemplate/KlondikeInputInterpreter',[
		'absolute/debug',
		'Arkadium/GameEngine/Core/EngineManagers',
		'SolitaireShared/CardLogic/CardAction',
		'SolitaireShared/CardLogic/CardValue',
		'SolitaireShared/CardLogic/CardSuit',
		'CardUI/PileView',
		'util/SettingsManager',
		'SolitaireShared/CardLogic/Pile'],
	function (Debug, EngineManagers, CardAction, CardValue, CardSuit, PileView, SettingsManager, Pile) {
		var KlondikeInputInterpreter = function (authority) {
			this.initKlondikeInputInterpreter(authority);
		};

		KlondikeInputInterpreter.DoubleClickThreshold = 700;


		//public delegate void CardMoveHandle(Card card, Pile fromPile, Pile toPile, CardAction action);
		//public event CardMoveHandle CardMove;

		KlondikeInputInterpreter.prototype.initKlondikeInputInterpreter = function (authority) {

			this.Authority = authority;

			this.IsClickedOnCard = false;
			this.InputEnabled = true;


			this.HighlightedCard = null;
			this.HighlightTime = -1;

			//this.CardMove = ?
		};

		/// <summary>
		/// Return a no-op action if the action is allowed, an error action if it's not allowed, or an actual action to perform if this does something.
		/// </summary>
		/// <param name="cardPickedUp"></param>
		/// <returns></returns>
		KlondikeInputInterpreter.prototype.Grab = function (cardPickedUp) {
			var grabList = [];

			var supplyView = cardPickedUp.SupplyView;
			var owningPile = cardPickedUp.Card.Pile;

			// Can't grab a card directly from the stock!
			if (owningPile.Name == "Stock")
				return grabList;

			var owningPileView = supplyView.GetPileView(owningPile);

			// Can't grab a face down card!
			if (owningPileView.CardFacing != PileView.Facing.FaceUp)
				return grabList;

			var cardPos = owningPile.GetCardPosFromEnd(cardPickedUp.Card);
			if (cardPos > 0) {
				for (var pos = owningPile.Count - cardPos; pos < owningPile.Count; pos++) {
					var card = owningPile.GetCardAtPos(pos);
					if (card != null) {
						var cardView = supplyView.GetCardView(card);
						if (cardView != null) grabList.Add(cardView);
					}
				}
			}
			return grabList;
		};

		KlondikeInputInterpreter.prototype.Drag = function (cardDragged, distance) {
			return true;
		};


		KlondikeInputInterpreter.prototype.NotifyCardsMoved = function () {
			this.ClearHighlight();
		};


		/// <summary>
		/// Build an action to move a card from one pile to another. Return true if action was built.
		/// </summary>
		KlondikeInputInterpreter.prototype.DoMoveCard = function (card, fromPile, toPile, action) {
			if (this.CardMove != null) {
				this.CardMove.Invoke(card, fromPile, toPile, action);//TODO:[tkachenko] Make it async
			}

			var count = fromPile.GetCardPosFromEnd(card);

			if (fromPile.Type == "Tableau") {
				var faceDownPile = this.Authority.FaceDownForTableau(fromPile);
				if (faceDownPile != null && faceDownPile.Count > 0 && fromPile.Count == count) {
					action.Parse(["begin",
						"move", fromPile.Name, toPile.Name, count.toString(),
						"move", faceDownPile.Name, fromPile.Name, "1",
						"end"]);
					if (action.IsAllowed())
						this.Authority.CardSupply.OnFlipCard(/* TODO new EventArgs() */);
				} else {
					action.Parse(["move", fromPile.Name, toPile.Name, count.toString()]);
				}
			} else if (fromPile.Type == "Waste") {
				action.Parse(["move", fromPile.Name, toPile.Name, count.toString()]);
			} else if (fromPile.Type == "Foundation") {
				action.Parse(["move", fromPile.Name, toPile.Name, count.toString()]);
			} else {
				return false;
			}

			return true;
		};


		KlondikeInputInterpreter.prototype.Drop = function (cardDropped, dropPiles) {
			var soundHasBeenPlayed = false;

			var cardSupply = cardDropped.Card.Supply;
			var action = new CardAction(cardSupply);
			action.Parse(["noop"]);

			for (var i = 0; i < dropPiles.length; i++) {
				var dropPile = dropPiles[i];
				var card = cardDropped.Card;
				var fromPile = card.Pile;
				var toPile = (dropPile instanceof Pile) ? dropPile : dropPile.Pile;

				if (fromPile != toPile) {
					// if we dropped the card to a new pile, clear its highlight.
					// otherwise let it stay highlighted
					this.ClearHighlight();
					this.DoMoveCard(card, fromPile, toPile, action);

					if (action.IsAllowed()) {

						if (toPile.Type == "Foundation") {
							EngineManagers.Sounds.PlaySound("foundation");
							soundHasBeenPlayed = true;
						} else {
							EngineManagers.Sounds.PlaySound("legalMove");
							soundHasBeenPlayed = true;
						}
						break;
					}
				}
			}


			if (!soundHasBeenPlayed) {
				EngineManagers.Sounds.PlaySound("illegalMove");
			}


			return action;
		};

		KlondikeInputInterpreter.TryFoundationPiles = ["Foundation0", "Foundation1", "Foundation2", "Foundation3"];

		KlondikeInputInterpreter.prototype.ClickCard = function (cardClicked, rightClicked) {
			var cardSupply = cardClicked.Card.Supply;
			var action = new CardAction(cardSupply);
			action.Parse(["noop"]);

			if (!this.InputEnabled) return action;

			if (rightClicked) {
				this.OrganizeDoubleClick(cardClicked, action, false);
				//TryAutoSolve(cardClicked.SupplyView);
				// return a no-op action -- but we are going to try to autosolve instead
				return action;
			}

			if (this.IsCardHighlighted() && cardClicked.Card.Pile.Type != "Stock") {
				if (this.HighlightedCard == cardClicked && cardClicked.Card.Pile.Type != "Foundation") {
					// check for double-click
					var CurrentTime = EngineManagers.Time.TotalGameTime.TotalMilliseconds;
					if ((!SettingsManager.getSetting('default', 'singleTapToMove')) &&
						(CurrentTime - this.HighlightTime < KlondikeInputInterpreter.DoubleClickThreshold)) {
						// double-clicked! find a pile for us
						var FoundationPile = null;
						if (cardClicked.Card.Value == CardValue.Values.Ace && this.Authority.CardSupply.EnforceGameRules) {
							// find empty foundation
							for (var i = 0; i < KlondikeInputInterpreter.TryFoundationPiles.length; i++) {
								var FoundationPileStr = KlondikeInputInterpreter.TryFoundationPiles[i];

								FoundationPile = this.Authority.CardSupply.GetPile(FoundationPileStr);
								if (FoundationPile.Empty)
									break;
								else
									FoundationPile = null;
							}
						} else {
							// find matching foundation
							for (var i = 0; i < KlondikeInputInterpreter.TryFoundationPiles.length; i++) {
								var FoundationPileStr = KlondikeInputInterpreter.TryFoundationPiles[i];
								FoundationPile = this.Authority.CardSupply.GetPile(FoundationPileStr);
								if ((!this.Authority.CardSupply.EnforceGameRules && FoundationPile.Count < 13) ||
									(!FoundationPile.Empty &&
										cardClicked.Card.Suit == FoundationPile.Top.Suit &&
										cardClicked.Card.ValueNum == FoundationPile.Top.ValueNum + 1)) {
									this.ClearHighlight();
									break;
								} else
									FoundationPile = null;
							}
						}
						if (FoundationPile != null && cardClicked.Card == cardClicked.Card.Pile.Top) {
							this.DoMoveCard(cardClicked.Card, cardClicked.Card.Pile, FoundationPile, action);

							EngineManagers.Sounds.PlaySound("foundation");
							this.ClearHighlight();
						}
					} else {
						this.HighlightTime = EngineManagers.Time.TotalGameTime.TotalMilliseconds;
					}
				} else {
					var card = this.HighlightedCard.Card;
					var fromView = this.HighlightedCard.Parent;

					var fromPile = card.Pile;
					var toPile = cardClicked.Card.Pile;

					if (fromPile != toPile) {
						this.DoMoveCard(card, fromPile, toPile, action);

						if (action.IsAllowed()) {
							this.ClearHighlight();

							// Make the player release mouse button and click again to drag the destination card
							// because immediate dragging after a click move causes shadow and layering bugs.
							cardClicked.IsDragging = cardClicked.SupplyView.IsCardDragging = false;
						} else {
							// XXXCBR: Uncomment if MS reopens 191785
							//if (toPile.Type != "Waste" || cardClicked.Card == toPile.Top) {
							this.HighlightCard(cardClicked)
							//}
						}
					} else if (this.Authority.CanPickupCard(cardClicked.Card)) {
						// Select a different card in the same pile.
						this.HighlightCard(cardClicked);
					}


					if (action.IsAllowed()) {
						if (cardClicked.Card.Pile.Type == "Foundation") {
							EngineManagers.Sounds.PlaySound("foundation");
						} else {
							EngineManagers.Sounds.PlaySound("legalMove");
						}
					}
				}
			} else {
				var pile = cardClicked.Card.Pile;
				if (pile.Name == "Stock" && !pile.Supply.WaitingForAnimation) {
					var Limit = parseInt(this.Authority.CardSupply.GetOption("Draw"));
					var count = pile.Count;
					if (count > Limit) count = Limit;
					action.Parse(["move", "Stock", "Waste", (-count).toString()]);

					var waste = cardClicked.SupplyView.GetPileView("Waste");
					if (pile.Supply.GetOption("Draw") == "3") {
						waste.FanLimit = 3;
					}

					this.Authority.CardSupply.OnFlipCard(/* new EventArgs() */);

					this.ClearHighlight();
				} else {
					if (this.Authority.CanPickupCard(cardClicked.Card)) {
						this.HighlightCard(cardClicked);
					}
				}
			}

			return action;
		};

		KlondikeInputInterpreter.prototype.OrganizeDoubleClick = function (cardClicked, action, checkClickTime) {
			// check for double-click
			var CurrentTime = EngineManagers.Time.TotalGameTime.TotalMilliseconds;
			if ((!SettingsManager.getSetting('default', 'singleTapToMove')) &&
				((CurrentTime - this.HighlightTime < KlondikeInputInterpreter.DoubleClickThreshold) || !checkClickTime)) {
				// double-clicked! find a pile for us
				var FoundationPile = null;
				if (cardClicked.Card.Value == CardValue.Values.Ace && this.Authority.CardSupply.EnforceGameRules && cardClicked.Card.Pile.Type != "Foundation") {
					// find empty foundation
					for (var i = 0; i < KlondikeInputInterpreter.TryFoundationPiles.length; i++) {
						var FoundationPileStr = KlondikeInputInterpreter.TryFoundationPiles[i];
						FoundationPile = this.Authority.CardSupply.GetPile(FoundationPileStr);
						if (FoundationPile.Empty)
							break;
						else
							FoundationPile = null;
					}
					this.ClearHighlight();
				} else {
					// find matching foundation
					for (var i = 0; i < KlondikeInputInterpreter.TryFoundationPiles.length; i++) {
						var FoundationPileStr = KlondikeInputInterpreter.TryFoundationPiles[i];
						FoundationPile = this.Authority.CardSupply.GetPile(FoundationPileStr);
						if ((!this.Authority.CardSupply.EnforceGameRules && FoundationPile.Count < 13) ||
							(!FoundationPile.Empty &&
								cardClicked.Card.Suit == FoundationPile.Top.Suit &&
								cardClicked.Card.ValueNum == FoundationPile.Top.ValueNum + 1)) {
							this.ClearHighlight();
							break;
						} else
							FoundationPile = null;
					}
				}
				if (FoundationPile != null && cardClicked.Card.Equals(cardClicked.Card.Pile.Top) && cardClicked.Parent.CardFacing == PileView.Facing.FaceUp) {
					this.DoMoveCard(cardClicked.Card, cardClicked.Card.Pile, FoundationPile, action);

					EngineManagers.Sounds.PlaySound("foundation");
					this.ClearHighlight();
				}
			} else {
				this.HighlightTime = EngineManagers.Time.TotalGameTime.TotalMilliseconds;
			}
		};

		KlondikeInputInterpreter.prototype.ClickEmptyPile = function (pileClicked) {
			var cardSupply = pileClicked.Pile.Supply;
			var action = new CardAction(cardSupply);
			action.Parse(["noop"]);

			if (!this.InputEnabled) return action;

			if (this.IsCardHighlighted()) {
				var card = this.HighlightedCard.Card;
				var fromPile = card.Pile;
				var toPile = pileClicked.Pile;
				this.DoMoveCard(card, fromPile, toPile, action);
				this.ClearHighlight();
				EngineManagers.Sounds.PlaySound("legalMove");
			} else {
				var pile = pileClicked.Pile;
				if (pile.Name == "Stock" && !pileClicked.SupplyView.CardSupply.WaitingForAnimation) {
					var wastePile = cardSupply.GetPile("Waste");
					action.Parse(["move", "Waste", "Stock", (-wastePile.Count).toString()]);

					if (action.IsAllowed()) {
						EngineManagers.Sounds.PlaySound("drawReset");
					}
				} else {
					// nothing to do if we click an empty pile other than the stock without a card highlighted
				}
			}
			return action;
		};

		KlondikeInputInterpreter.prototype.ClickOutside = function () {
			// Clear the selected card
			this.ClearHighlight();
		};


		KlondikeInputInterpreter.prototype.IsCardHighlighted = function () {
			return (this.HighlightedCard != null);
		};

		KlondikeInputInterpreter.prototype.GetHighlightedCard = function () {
			return this.HighlightedCard;
		};

		KlondikeInputInterpreter.prototype.removeHighlightedCard = function () {
			this.HighlightedCard = null;
		};


		KlondikeInputInterpreter.prototype.HighlightCard = function (card) {
			if (card != this.HighlightedCard) {
				this.ClearHighlight();
				this.HighlightedCard = card;
				this.HighlightTime = EngineManagers.Time.TotalGameTime.TotalMilliseconds;
			}
			Debug.log("HighlightCard(" + card.Card + ")");
			// notify UI?
		};

		KlondikeInputInterpreter.prototype.ClearHighlight = function () {
			if (this.HighlightedCard != null) {
				this.HighlightedCard = null;
				this.HighlightTime = -1;
			}
			Debug.log("ClearHighlight()");
			// notify UI?
		};

		KlondikeInputInterpreter.prototype.TryAutoSolve = function (supplyView) {
			var numFoundations = 4;

			if (this.Authority != null /*&& AuthorityReference.CanAutoSolve()*/) {
				var suitToFoundation = {};

				// Figure out which suits go to which foundations
				var suitsToInsert = new [CardSuit.Hearts, CardSuit.Diamonds, CardSuit.Clubs, CardSuit.Spades];

				for (var i = 0; i < numFoundations; i++) {
					var foundation = this.Authority.CardSupply.GetPile("Foundation" + i);
					if (!foundation.Empty) {
						var suit = foundation.Top.Suit;
						suitToFoundation[suit] = foundation;
						suitsToInsert.splice(suitsToInsert.indexOf(suit), 1);
					}
				}

				if (suitsToInsert.length > 0) {
					for (var i = 0; i < numFoundations; i++) {
						var foundation = this.Authority.CardSupply.GetPile("Foundation" + i);
						if (foundation.Empty) {
							var suit = suitsToInsert[0];
							suitToFoundation[suit] = foundation;
							suitsToInsert.splice(0, 1);
						}
					}
				}

				var AUTO_MOVE_INTERVAL = 100;
				var timeSinceLastAutoMove = 0;

				// TODO
				/*
				EventHandler<EventArgs> onUpdate = null;
				onUpdate = (sender, time) =>
				{
					timeSinceLastAutoMove += EngineManagers.Time.ElapsedGameTime.Milliseconds;

					if (timeSinceLastAutoMove > AUTO_MOVE_INTERVAL)
					{
						timeSinceLastAutoMove = 0;

						if (AutoSolve_DoNextMove(suitToFoundation))
						{
							supplyView.OnMoveCards();
						}
						else
						{
							supplyView.Updated -= onUpdate;
						}
					}
				};
				supplyView.Updated += onUpdate;
				*/
			}
		};

		KlondikeInputInterpreter.prototype.AutoSolve_DoNextMove = function (suitToFoundation) {
			var source;
			var destination;
			var numTableaus = 7;

			if (suitToFoundation[CardSuit.Hearts].Count < 13 || suitToFoundation[CardSuit.Clubs].Count < 13 ||
				suitToFoundation[CardSuit.Diamonds].Count < 13 || suitToFoundation[CardSuit.Spades].Count < 13) {
				var action = new CardAction(this.Authority.CardSupply);

				// Check Waste
				source = Authority.CardSupply.GetPile("Waste");
				if (!source.Empty) {
					destination = suitToFoundation[source.Top.Suit];
					this.DoMoveCard(source.Top, source, destination, action);
					if (action.Run(false)) {
						EngineManagers.Sounds.PlaySound("foundation");
						return true;
					}
				}

				// Iterate through Tableaus
				for (var i = 0; i < numTableaus; i++) {
					source = this.Authority.CardSupply.GetPile("Tableau" + i);
					if (!source.Empty) {
						destination = suitToFoundation[source.Top.Suit];
						this.DoMoveCard(source.Top, source, destination, action);
						if (action.Run(false)) {
							EngineManagers.Sounds.PlaySound("foundation");
							return true;
						}
					}
				}
			}

			return false;
		};

		KlondikeInputInterpreter.prototype.ShouldMoveKeyboard = function (action, card) {
			return false;
		};

		KlondikeInputInterpreter.prototype.DealNextFromStock = function (supplyView) {
			var cardSupply = this.Authority.CardSupply;
			var action = new CardAction(cardSupply);
			var cardsInStock = cardSupply.GetPile("Stock").Count;
			var cardsInWaste = cardSupply.GetPile("Waste").Count;
			var drawOption = parseInt(cardSupply.GetOption("Draw"));

			if (cardSupply.GetPile("Stock").Empty) {
				action.Parse(["begin", "move", "Waste", "Stock", "-" + cardsInWaste, "end"]);
				if (action.IsAllowed()) {
					EngineManagers.Sounds.PlaySound("drawReset");
				}
			} else if (cardsInStock <= drawOption) {
				action.Parse(["begin", "move", "Stock", "Waste", "-" + cardsInStock, "end"]);
			} else {
				action.Parse(["begin", "move", "Stock", "Waste", "-" + drawOption, "end"]);
			}
			if (action.IsAllowed()) {
				if (drawOption == 3 && cardsInStock >= 3) {
					EngineManagers.Sounds.PlaySound("threeCards");
				} else {
					EngineManagers.Sounds.PlaySound("singleCard");
				}
			}
			if (action.Run()) {
				if (drawOption == 3) {
					supplyView.setActiveLastCard(drawOption);

				} else if( drawOption == 1) {
					supplyView.setActiveLastCard(drawOption);
				}
			}
		};

		return KlondikeInputInterpreter;


	});

